// components/Button.jsx
import React from "react";

const Button = ({
  children,
  onClick,
  className = "",
  type = "button",
  disabled = false,
  variant = "primary", // "primary" | "outline"
}) => {
  // base classes for all buttons
  const baseClasses =
    "flex items-center justify-center rounded-md px-2 py-1.5 text-sm font-medium transition duration-200";

  // classes for variants
  const variantClasses = {
    primary:
      "border border-brand-500 bg-brand-500 text-white hover:bg-brand-600 active:bg-brand-700 dark:border-brand-400 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200",

    outline:
      "border border-brand-500 bg-transparent text-brand-500 hover:bg-brand-500 hover:text-white active:bg-brand-600 dark:border-brand-400 dark:text-brand-400 dark:hover:bg-brand-400 dark:hover:text-white dark:active:bg-brand-300",

    red: "border border-red-600 bg-red-600 text-white hover:bg-red-700 active:bg-red-800 dark:border-red-500 dark:bg-red-500 dark:text-white dark:hover:bg-red-600 dark:active:bg-red-700",

    orange:
      "border border-orange-600 bg-orange-600 text-white hover:bg-orange-700 active:bg-orange-800 dark:border-orange-500 dark:bg-orange-500 dark:text-white dark:hover:bg-orange-600 dark:active:bg-orange-700",

    green:
      "border border-green-600 bg-green-600 text-white hover:bg-green-700 active:bg-green-800 dark:border-green-500 dark:bg-green-500 dark:text-white dark:hover:bg-green-600 dark:active:bg-green-700",
  };

  const disabledClasses = disabled ? "cursor-not-allowed opacity-50" : "";

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variantClasses[variant]} ${disabledClasses} ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
